<template>
  <div>
    <Modal
      v-model="modal1"
      :title="'区域查询结果（' + chacheData.length + '）'"
      footer-hide
      width="1100"
    >
      <Table
        width="100%"
        height="400"
        no-data-text="<div class='table-no-data'></div>"
        :columns="columns2"
        :data="chacheData"
      ></Table>
    </Modal>
  </div>
</template>
<script>

export default {
  data() {
    return {
      modal1: false,
      chacheData: [], //查询到的车的数据
      columns2: [
        {
          type: "index",
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
        },
        {
          title: "设备类型",
          key: "deviceModel",
        },
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "车辆类型",
          key: "carTypeName",
        },
        {
          title: "人员名字",
          key: "personName",
        },
        {
          title: "所属单位",
          key: "groupName",
        },
      ],
    };
  },
  methods: {
    //区域查车结果处理
    areaCarFunction(pts) {
      this.utils.loading(this, "查车中");
      let params = {
        pointList: pts,
        orgCoord: 2,
        //pageNumber: 0,
        //pageSize: 0,
      };
      this.axios({
        method: "post",
        url: this.axios.lbs + "/locate/findDevice",
        data: params,
      }).then((res) => {
        this.modal1 = true;
        this.$Spin.hide(); //关闭加载
        this.chacheData = res.data.data.dataList;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/locate/quyuchache.vue